<template>
  <div class="ofs-amount" :class="{ 'ofs-amount--dynamic': dynamic }" @click="handleClick">
    {{ amountFormatter(amount) }}
  </div>
</template>

<script setup lang="ts">
import { TransactionSettings } from '@types'

import { displayAmount } from '@/entities/transactions/utils/helpers'

type Props = {
  amount: number
  dynamic: boolean
  entrySettings?: TransactionSettings['entries'][number]
}

type Emits = {
  'click': []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const amountFormatter = (value: number | null | undefined) => {
  const settings = props.entrySettings?.amount
  if (!settings) return ''
  const isPercent = settings.rule === 'percent'
  return displayAmount(value, isPercent)
}

const handleClick = () => {
  if (!props.dynamic) return
  emit('click')
}
</script>

<style>
.ofs-amount {
  @apply text-[10px] text-light-text font-normal;
  @apply bg-body-dark;
  @apply px-1;
  @apply rounded;

  &--dynamic {
    @apply hover:bg-primary-light;
    @apply cursor-pointer;
  }
}
</style>
